import React, { useEffect, useMemo } from 'react';
import WaitingForIncidentMessage from '../shared/IncidentWidgets/WaitingForIncidentMessage';
import { connect } from 'react-redux';
import { orderBy } from 'lodash';
import { selectors as dashboardSelectors } from '../../../../state/modules/dashboards';
import { activeIncidents, selectCurrentDisplayedIncident } from '../../../../state/modules/incidents/selectors';
import './index.css';
import IncidentListItem from './IncidentListItem';
import SettingsForm from '../ui-kit/SettingsForm';

const Settings = ({ updateWidgetSettingsField, widgetSettings }) => (
  <SettingsForm
    updateWidgetSettingsField={updateWidgetSettingsField}
    widgetSettings={widgetSettings}
    withAutoResizeHeight={true}
    withAutoScroll={true}
  />
);

const ActiveIncidentList = ({
  activeIncidents,
  displayedIncident,
  skills,
  dashboardAPIManager,
  editMode,
  setDisplayedIncident,
  incidentLocked,
  toggleIncidentLock
}) => {
  useEffect(() => {
    dashboardAPIManager.fetchTasks();
    dashboardAPIManager.fetchSkills();
    dashboardAPIManager.fetchGroupAndSubgroups();
  }, [dashboardAPIManager]);

  // This widget needs to display all incidents that belong to a station, we use
  // stationToIncidentsMap to fetch incidents of current station only. If the group
  // is a cluster or region, children station incidents should also be dislayed
  let incidents = useMemo(() => orderBy(activeIncidents || [], ['created_at'], ['desc']), [activeIncidents]);

  // if we're in editMode and there are no active incidents, show dummy data
  // passed in through the displayedIncident
  if (editMode && incidents.length === 0) {
    incidents = [displayedIncident];
  }

  if (!skills.lastFetch || incidents.length === 0) return <WaitingForIncidentMessage />;

  return (
    <>
      {incidents.map(incident => (
        <IncidentListItem
          key={incident.id}
          incident={incident}
          skills={skills}
          displayedIncidentId={displayedIncident.id}
          setDisplayedIncident={setDisplayedIncident}
          incidentLocked={incidentLocked}
          toggleIncidentLock={toggleIncidentLock}
        />
      ))}
    </>
  );
};

const mapStateToProps = state => ({
  activeIncidents: activeIncidents(state),
  skills: state.skills,
  dashboardEditMode: dashboardSelectors.editMode,
  displayedIncident: selectCurrentDisplayedIncident(state)
});

const ConnectedActiveIncidentList = connect(mapStateToProps)(React.memo(ActiveIncidentList));

Object.assign(ConnectedActiveIncidentList, {
  SettingsContent: Settings
});

export default ConnectedActiveIncidentList;
